import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { FuseFullscreenModule } from '@fuse/components/fullscreen';
import { FuseLoadingBarModule } from '@fuse/components/loading-bar';
import { FuseNavigationModule } from '@fuse/components/navigation';
import { TranslocoModule } from '@ngneat/transloco';

import { Languages_Module } from 'app/layout/common/languages/languages.module';
import { Shared_Module } from 'app/shared/shared.module';
import { Store_Layout_Component } from 'app/layout/layouts/store/store.component';
import { User_Module } from 'app/layout/common/user/user.module';

@NgModule({
    declarations: [
        Store_Layout_Component,
    ],
    imports: [
        HttpClientModule,
        RouterModule,
        MatButtonModule,
        MatDividerModule,
        MatIconModule,
        MatMenuModule,
        FuseFullscreenModule,
        FuseLoadingBarModule,
        FuseNavigationModule,
        TranslocoModule,

        Languages_Module,
        User_Module,
        Shared_Module
    ],
    exports: [
        Store_Layout_Component
    ]
})
export class Store_Layout_Module {
}
